import type { ProviderGetImage } from '@nuxt/image'

// Provider "no-op": renvoie l'URL source telle quelle
export const getImage: ProviderGetImage = (src) => {
  return { url: src }
}